module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/green/score_gauge_icon-39316ad8be2be02eb8f17fd0d402c0b4.svg";